module.exports = __webpack_public_path__ + "img/5.587eb8f3.png";